import { useEffect, useState } from 'react'
import { get } from 'libraries/lodash'

const useNewsTickerItems = ({ CMS_DATA }) => {
  const [newsItems, setNewsItems] = useState()

  useEffect(() => {
    const _newsItems = get(CMS_DATA, 'results[0].data.news_entry', [])
      .map(({ news_entry_text: newsEntryText }) => newsEntryText)
    setNewsItems(_newsItems)
  }, [CMS_DATA])

  return {
    newsItems
  }
}

export default useNewsTickerItems
